// Polish message catalog. Keys must stay in sync with `en.ts` (MessageKey).
import type { MessageKey } from './en';

export const pl: Record<MessageKey, string> = {
  'app.title': 'GitexTrade',
  'nav.dashboard': 'Pulpit',
  'nav.positions': 'Pozycje',
  'nav.settings': 'Ustawienia',
  'nav.watchlist': 'Obserwowane',
  'nav.momentum': 'Momentum',
  'lang.toggle': 'EN',
  'alert.dismiss': 'Zamknij',
  'dashboard.killSwitch': 'Wyłącznik awaryjny',
  'dashboard.engineIdle': 'Silnik bezczynny — brak podłączonych adapterów.',
  'dashboard.title': 'Panel Handlu Algorytmicznego',
  'dashboard.status': 'Status Połączenia Silnika',
  'dashboard.active': 'Aktywny (Alpaca API Paper Trading)',
  'dashboard.inactive': 'Bezczynny (Brak Kluczy API)',
  'dashboard.engineUnreachable': 'Bezczynny (Silnik Niedostępny)',
  'dashboard.toggleUnreachable': 'Nie udało się połączyć z silnikiem. Czy nadal działa?',
  'dashboard.pnl': 'Dzienny Niezrealizowany PnL',
  'dashboard.charts': 'Wykresy Cen na Żywo (Skala 15m)',
  'dashboard.positionsTitle': 'Bieżące Pozycje',
  'dashboard.noPositions': 'Brak aktywnych pozycji na giełdzie.',
  'dashboard.summaryTitle': 'Podsumowanie Aktywnych Reguł',
  'settings.title': 'Ustawienia Połączenia',
  'settings.exchange': 'Aktywny Adapter Giełdy',
  'settings.alpacaKey': 'Identyfikator Klucza API Alpaca',
  'settings.alpacaSecret': 'Tajny Klucz API Alpaca',
  'settings.paper': 'Tryb Handlu Papierowego (Paper)',
  'settings.save': 'Zastosuj i Zapisz Ustawienia',
  'settings.saved': 'Konfiguracja została pomyślnie zapisana i wdrożona!',
  'settings.strategyTitle': 'Parametry Strategii Technicznej (Momentum)',
  'settings.riskTitle': 'Kontrola Ryzyka i Alokacja Wolumenu',
  'settings.sentimentTitle': 'Filtrowanie Nastrojów Społecznych',
  'settings.emaFast': 'Okres Szybkiego EMA',
  'settings.emaSlow': 'Okres Wolnego EMA',
  'settings.rsiPeriod': 'Okres Wskaźnika RSI',
  'settings.rsiOverbought': 'Poziom Wykupienia RSI',
  'settings.rsiOversold': 'Poziom Wyprzedania RSI',
  'settings.hftTakeProfitPct': 'Poziom Take Profit HFT (%)',
  'settings.hftStopLossPct': 'Poziom Stop Loss HFT (%)',
  'settings.volPeriod': 'Okres Średniej Wolumenu SMA',
  'settings.volMult': 'Mnożnik Skoku Wolumenu (x)',
  'settings.riskTrade': 'Ryzyko na Transakcję (% Kapitału)',
  'settings.atrStop': 'Krotność Stop Loss ATR',
  'settings.maxPos': 'Maks. Równoległych Pozycji',
  'settings.drawdown': 'Dzienny Limit Straty (%)',
  'settings.sentimentThresh': 'Próg Bramki Nastroju Wejścia',
  'settings.sentimentActive': 'Włącz Ochronę Nastroju',
  'settings.geminiKey': 'Klucz API Gemini (Analiza Nastrojów)',
  'settings.sendToServer': 'Wyślij Klucze do Lokalnego Serwera',
  'settings.serverConfigured': 'Serwer skonfigurowany ✓ — klucze API aktywne',
  'settings.serverNotConfigured': 'Klucze nie zostały jeszcze wysłane do serwera',
  'settings.serverSection': 'Konfiguracja Lokalnego Silnika',
  'settings.serverUrl': 'Adres URL Serwera Silnika',
  'dashboard.startBot': 'Uruchom Silnik',
  'dashboard.stopBot': 'Zatrzymaj Silnik',
  'risk.panelTitle': 'Awaryjna Kontrola Ryzyka',
  'risk.killSwitchOn': 'Włącz Wyłącznik Awaryjny',
  'risk.killSwitchOff': 'Zwolnij Wyłącznik Awaryjny',
  'risk.killSwitchEngaged': 'Wyłącznik awaryjny AKTYWNY — każdy cykl handlowy jest zablokowany.',
  'risk.flatten': 'ZAMKNIJ WSZYSTKO',
  'risk.flattenConfirm': 'Potwierdź: zamknąć WSZYSTKIE pozycje?',
  'risk.flattenDone': 'Wszystkie pozycje zamknięte, silnik zatrzymany.',
  'risk.flattenPartial': 'Niektórych pozycji nie udało się zamknąć — sprawdź log silnika.',
  'risk.flattenFailed': 'Żądanie zamknięcia nie powiodło się. Czy silnik jest dostępny?',
  'risk.dailyBudget': 'Wykorzystany dzienny limit straty',
  'risk.drawdownBudget': 'Wykorzystany limit obsunięcia portfela',
  'risk.breakerTripped': 'BEZPIECZNIK ZADZIAŁAŁ',
  'dashboard.equity': 'Kapitał Konta Alpaca',
  'dashboard.buyingPower': 'Moc Zakupowa',
  'dashboard.openPositions': 'Otwarte Pozycje',
  'dashboard.symbol': 'Symbol',
  'dashboard.side': 'Strona',
  'dashboard.quantity': 'Ilość',
  'dashboard.entryPrice': 'Cena Wejścia',
  'dashboard.currentPrice': 'Aktualna Cena',
  'dashboard.unrealizedPnl': 'Niezrealizowany PnL',
  'settings.strategyMode': 'Tryb Strategii',
  'settings.activeStrategy': 'Aktualnie działająca na silniku',
  'settings.unsavedStrategyWarning':
    'Wybrano inną strategię, ale nie została jeszcze zapisana — silnik nadal handluje na strategii powyżej. Kliknij "Zastosuj i Zapisz Ustawienia", aby aktywować wybór.',
  'settings.strategyMomentum': 'Momentum (Konserwatywny)',
  'settings.strategyScalping': 'RSI Scalping (Agresywny)',
  'settings.strategyMomentumDesc': 'Przecięcie EMA 15m · 1-5 pozycji/tydzień',
  'settings.strategyScalpingDesc': 'Odbicia RSI 5m · 5-15 pozycji/dzień',
  'settings.strategyFunding': 'Funding Rate Arbitrage (Krypto Delta-Neutral)',
  'settings.strategyFundingDesc': 'Spot Long + Perp Short · Zysk ze stóp fin.',
  'settings.strategyStatArb': 'ETH/BTC Stat Arb (Krypto Spread)',
  'settings.strategyStatArbDesc': 'Z-Score Mean Reversion · Handel parą aktywów',
  'settings.strategyMeanReversion': 'Powrót do średniej (kupno dołków RSI)',
  'settings.strategyMeanReversionDesc': 'Kupno przy wyprzedaniu RSI 15m · handluje w każdym trendzie',
  'settings.strategyGitexTrade': 'GITEX TRADE (Inteligentna Multi-Strategia)',
  'settings.strategyGitexTradeDesc': 'Analizuje wszystkie aktywne strategie jednocześnie w czasie rzeczywistym i uruchamia tę, która ma najwyższe prawdopodobieństwo zysku w danym momencie.',
  'settings.maxTotalDrawdown': 'Stoper portfela — Maks. strata całkowita (%)',
  'settings.alertsTitle': 'Alerty i Monitoring (Prywatne)',
  'settings.alertsDesc':
    'Każda instancja silnika należy tylko do Ciebie — wklej tutaj własnego bota Telegram, webhook Discord i adres URL UptimeRobot Heartbeat. Znajomi uruchamiający własną kopię bota konfigurują swoje dane niezależnie od Twoich.',
  'settings.telegramBotToken': 'Token Bota Telegram',
  'settings.telegramChatId': 'ID Czatu Telegram',
  'settings.discordWebhookUrl': 'URL Webhooka Discord',
  'settings.uptimerobotHeartbeatUrl': 'URL Heartbeat UptimeRobot',
  'settings.maxPosSize': 'Maks. Rozmiar Pozycji (USD)',
  'settings.strategyHybrid': 'Strategia Hybrydowa (Dynamiczny Adapter)',
  'settings.strategyHybridDesc': 'Routing siły trendu ADX · Momentum (>25) vs Powrót do średniej (<20)',
  'settings.strategyAggressiveKoziel': 'Agresywny Kozieł (Scalping)',
  'settings.strategyAggressiveKozielDesc': 'Świece 1m · HMA(55) trend · Stochastic RSI crossovers <15/>85 · Impuls wolumenu',
  'settings.strategyHftArbitrage': 'HFT / Arbitraż',
  'settings.strategyHftArbitrageDesc': 'Tysiące transakcji/dobę · Winrate 80%-99% · Mikro-gains na różnicach spreadu · Ogromny wolumen',
  'settings.strategySentimentMomentum': 'Sentiment Momentum (NASDAQ)',
  'settings.strategySentimentMomentumDesc': 'Handluje na watchliście Top 5 NASDAQ Momentum Score (patrz zakładka Momentum) · Byczy cross EMA9/21 + pasmo RSI · Tylko long, wejście warunkowane Momentum Score >= progu (domyślnie 0.6)',
  'tooltip.alpacaKey': 'Twój identyfikator klucza API Alpaca używany do składania zleceń.',
  'tooltip.alpacaSecret': 'Twój tajny klucz API Alpaca używany do autoryzacji.',
  'tooltip.paper': 'Przełącz tryb handlu papierowego, aby korzystać z konta demo.',
  'tooltip.strategyMode': 'Kieruje sygnały do trybu momentum, scalping, mean reversion lub hybrydowego.',
  'tooltip.strategyGitexTrade': 'Agreguje wszystkie modele i rozstrzyga konflikty sygnałów wejścia za pomocą wag priorytetów.',
  'tooltip.strategyMomentum': 'Strategia podążająca za trendem, która wchodzi w pozycję, gdy szybka wykładnicza średnia krocząca przecina od dołu wolną wykładniczą średnią kroczącą, przy potwierdzeniu wysokim wolumenem.',
  'tooltip.strategyScalping': 'Strategia wysokiej częstotliwości przeznaczona dla krótkich przedziałów czasowych, która wchodzi w pozycję, gdy wskaźnik siły względnej Relative Strength Index odbija w górę ze strefy wyprzedania.',
  'tooltip.strategyFunding': 'Strategia neutralna rynkowo, która utrzymuje długą pozycję na rynku spot i krótką pozycję na rynku swapów wieczystych w celu pobierania opłat finansowania.',
  'tooltip.strategyStatArb': 'Statystyczna strategia arbitrażowa oparta na powrocie do średniej, handlująca odchyleniem proporcji cen Ethereum do Bitcoin za pomocą odchylenia Z-score.',
  'tooltip.strategyMeanReversion': 'Strategia przeciwna do trendu, która kupuje, gdy wskaźnik siły względnej Relative Strength Index spada do strefy wyprzedania i zaczyna rosnąć, bez wymogu zgodności z trendem.',
  'tooltip.strategyHybrid': 'Dynamiczny adapter rynkowy, który oblicza średnią zmienność rynku za pomocą wskaźnika ruchu kierunkowego Average Directional Index i kieruje zlecenia do strategii Momentum lub Powrotu do średniej.',
  'tooltip.strategyAggressiveKoziel': 'Agresywny skalping obustronny (Long/Short) na świecach 1-minutowych z wyjściami TP/SL i przeciwnym biegunem Stochastic RSI oraz 5-minutowym cooldownem.',
  'tooltip.strategyHftArbitrage': 'Strategia animatora rynku o ultra-wysokiej częstotliwości (HFT) i mikro-arbitrażu spreadu. Celuje w ułamki centa przy gigantycznej liczbie transakcji z ciasnymi celami (+0.02% TP, -0.04% SL) oraz cyklem badania rynku co 1 sekundę.',
  'tooltip.strategySentimentMomentum': 'Strategia tylko-long na NASDAQ napędzana skanerem z zakładki Momentum: ocenia wyłącznie aktualną watchlistę Top 5 Momentum Score (sentyment Reddit/X/Finnhub + wolumen wzmianek), wchodzi na byczym crossie EMA9/21 wewnątrz pasma RSI, i tylko gdy Momentum Score przekroczy konfigurowalny próg (domyślnie 0.6). Najpierw skonfiguruj klucze API źródeł danych na zakładce Momentum — pusta watchlista oznacza brak transakcji.',
  'tooltip.emaFast': 'Okres szybkiej średniej EMA. [Strategie: Wszystkie]. Definiuje krótkoterminowy trend. Mniejsze wartości (np. 3) = częstsze kupno i szybsza reakcja w HFT/Scalping.',
  'tooltip.emaSlow': 'Okres wolnej średniej EMA. [Strategie: Wszystkie oprócz HFT]. Definiuje długoterminowy trend filtrujący szum. Większe wartości = bezpieczniejszy próg wejścia.',
  'tooltip.rsiPeriod': 'Okres wskaźnika RSI. [Strategie: Momentum, Scalping, MR, HFT]. Określa pęd cenowy. Zazwyczaj 14.',
  'tooltip.rsiOverbought': 'Poziom wykupienia RSI. [Strategie: Momentum, Scalping, MR]. Wyższy poziom = rzadsze zamykanie pozycji / więcej kupna w trendzie.',
  'tooltip.rsiOversold': 'Poziom wyprzedania RSI. [Strategie: MR, Scalping]. Niższy poziom = głębszy spadek wymagany do wejścia (bezpieczniejszy próg wejścia).',
  'tooltip.volPeriod': 'Okres wolumenu SMA. [Strategie: Momentum, Scalping, Kozieł]. Liczba historycznych świec do obliczenia średniej wolumenu.',
  'tooltip.volMult': 'Mnożnik wolumenu. [Strategie: Momentum, Scalping, Kozieł]. Wyższy mnożnik = bezpieczniejsze, ale rzadsze wejścia przy silnym skoku wolumenu.',
  'tooltip.riskTrade': 'Ryzyko na transakcję. [Strategie: Wszystkie oprócz HFT]. Procent kapitału ryzykowny na transakcję na bazie ATR. Zazwyczaj 1%.',
  'tooltip.atrStop': 'Krotność ATR. [Strategie: Wszystkie oprócz HFT]. Większa krotność = szerszy stop loss (mniejsze ryzyko przedwczesnego wyrzucenia z rynku).',
  'tooltip.maxPos': 'Maksymalna liczba pozycji. [Strategie: Wszystkie]. Zwiększenie tego limitu pozwala botowi na jednoczesne handlowanie większą liczbą aktywów.',
  'tooltip.drawdown': 'Dzienny limit straty. [Strategie: Wszystkie]. Poziom strat w danym dniu wyzwalający wyłącznik awaryjny.',
  'tooltip.hftTakeProfitPct': 'Docelowy zysk (Take Profit) dla transakcji HFT / Arbitraż. Mniejsze wartości = szybsze zamykanie zysków i częstszy handel.',
  'tooltip.hftStopLossPct': 'Limit straty (Stop Loss) dla transakcji HFT / Arbitraż. Mniejsze wartości = mniejsze ryzyko na transakcję, ale częstsze zamykanie pozycji.',
  'tooltip.maxPosSize': 'Maksymalna bezwzględna kwota w USD alokowana w pojedynczą pozycję.',
  'tooltip.maxTotalDrawdown': 'Zatrzymaj silnik, jeśli całkowity spadek kapitału przekroczy ten limit procentowy.',
  'tooltip.sentimentThresh': 'Minimalny próg sentymentu rynkowego wymagany do otwarcia pozycji długiej.',
  'tooltip.sentimentActive': 'Włącza/wyłącza filtrowanie na bazie nastrojów przed nowym trade.',
  'tooltip.geminiKey': 'Klucz API Gemini używany do analizy wiadomości i wyznaczania sentymentu.',
  'tooltip.telegramBotToken': 'Token bota Telegram od @BotFather do wysyłania powiadomień.',
  'tooltip.telegramChatId': 'ID czatu Telegram, na który będą wysyłane powiadomienia.',
  'tooltip.discordWebhookUrl': 'URL webhooka Discord do strumieniowania transakcji na Twój kanał.',
  'tooltip.uptimerobotHeartbeatUrl': 'Ping URL UptimeRobot do monitorowania sprawności pętli bota.',
  'tooltip.serverUrl': 'Bazowy adres URL uruchomionej instancji silnika handlowego (domyślnie: http://localhost:8000).',
  'footer.build': 'Build',
  'watchlist.title': 'Lista Obserwowanych Aktywów',
  'watchlist.addAsset': 'Dodaj Aktywo',
  'watchlist.symbol': 'Symbol',
  'watchlist.crypto': 'Kryptowaluta',
  'watchlist.stocks': 'Akcja / ETF',
  'watchlist.actions': 'Operacje',
  'watchlist.remove': 'Usuń',
  'watchlist.addButton': 'Dodaj',
  'watchlist.empty': 'Brak aktywów w tej kategorii.',
  'watchlist.successAdd': 'Aktywo zostało dodane pomyślnie.',
  'watchlist.successRemove': 'Aktywo zostało usunięte pomyślnie.',
  'watchlist.smartActive': 'Aktywuj inteligentną gorącą listę',
  'watchlist.smartActiveMsg': 'Lista obserwowanych jest zarządzana przez skaner momentum. Ręczne edytowanie jest wyłączone.',
  'tooltip.smartActive': 'Po włączeniu lista jest automatycznie synchronizowana z aktywami o najwyższym wolumenie i płynności (Top 100 Krypto / Top 1000 Akcji) dobranymi według wskaźników momentum.',
  'analytics.title': 'Analiza wyników',
  'analytics.timeframe': 'Zakres czasu',
  'analytics.loading': 'Ładowanie historii transakcji z Alpaca…',
  'analytics.error': 'Nie udało się załadować analizy wyników. Czy silnik jest osiągalny?',
  'analytics.empty': 'Brak zamkniętych transakcji w tym zakresie czasu.',
  'analytics.netPnl': 'Wynik netto',
  'analytics.winRate': 'Skuteczność',
  'analytics.profitFactor': 'Współczynnik zysku',
  'analytics.sharpe': 'Wskaźnik Sharpe\'a',
  'analytics.maxDrawdown': 'Maks. obsunięcie',
  'analytics.avgDuration': 'Śr. czas transakcji',
  'analytics.equityCurve': 'Krzywa kapitału',
  'analytics.pnlHistogram': 'Rozkład wyników',
  'analytics.winLoss': 'Zyski / straty',
  'analytics.wins': 'Zyskowne',
  'analytics.losses': 'Stratne',
  'analytics.trades': 'transakcji',
  'analytics.dataTable': 'Tabela danych',
  'analytics.tableTime': 'Czas',
  'analytics.tableEquity': 'Kapitał',
  'analytics.outOf': 'z',
  'analytics.tradeCount': 'Liczba transakcji',
  'analytics.pnlBracket': 'Przedział PnL',
  'topMovers.title': 'Top 5 Momentum NASDAQ',
  'topMovers.loading': 'Ładowanie liderów momentum…',
  'topMovers.error': 'Nie udało się wczytać wyników Momentum Score.',
  'topMovers.empty': 'Brak liderów NASDAQ Momentum — czekamy na kolejne skanowanie.',
  'topMovers.rank': 'Pozycja',
  'topMovers.symbol': 'Symbol',
  'topMovers.momentumScore': 'Momentum Score',
  'tooltip.momentumScore':
    'Ranking w skali 0–1 łączący ostatni sentyment (byczy/niedźwiedzi) ze źródeł Reddit r/wallstreetbets, X/Twitter i nagłówków Finnhub z tym, ile wzmianek dana spółka ma teraz w porównaniu do swojej niedawnej średniej — pełni tę samą rolę co RVOL dla momentum cenowo-wolumenowego. Punktowane są tylko spółki NASDAQ z co najmniej 3 łącznymi wzmiankami w oknie skanu; wartość 1.0 oznacza maksymalnie byczy sentyment i nietypowo wysoki wolumen wzmianek. W trybie strategii sentiment_momentum pozycja long otwiera się dopiero gdy wynik przekroczy konfigurowalny próg (domyślnie 0.6).',
  'topMovers.mentionCount': 'Wzmianki',
  'topMovers.marketOpen': 'NASDAQ otwarty',
  'topMovers.marketClosed': 'NASDAQ zamknięty',
  'topMovers.diag.title': 'Diagnostyka — co nie działa',
  'topMovers.diag.error': 'Nie udało się wczytać diagnostyki.',
  'topMovers.diag.reddit': 'Reddit',
  'topMovers.diag.twitter': 'Twitter/X',
  'topMovers.diag.finnhub': 'Finnhub',
  'topMovers.diag.tradingview': 'Skan TradingView',
  'topMovers.diag.lastScan': 'Ostatni skan',
  'topMovers.diag.never': 'nigdy',
  'topMovers.diag.candidates': 'Kandydaci NASDAQ',
  'topMovers.diag.mentionsReddit': 'Wzmianki Reddit',
  'topMovers.diag.mentionsTwitter': 'Wzmianki Twitter',
  'topMovers.diag.mentionsNews': 'Nagłówki newsów',
  'topMovers.diag.topMoversFound': 'Znalezieni liderzy',
  'topMovers.config.title': 'Klucze źródeł danych',
  'topMovers.config.redditClientId': 'Reddit Client ID',
  'topMovers.config.redditClientSecret': 'Reddit Client Secret',
  'topMovers.config.twitterBearerToken': 'X/Twitter Bearer Token',
  'topMovers.config.finnhubApiKey': 'Finnhub API Key',
  'topMovers.config.save': 'Zapisz klucze',
  'topMovers.config.saving': 'Zapisywanie…',
  'topMovers.config.saved': 'Klucze źródeł momentum zapisane.',
  'topMovers.config.saveError': 'Nie udało się zapisać kluczy źródeł momentum.',
  'topMovers.console.title': 'Konsola na żywo — aktywność skanera',
  'topMovers.console.error': 'Nie udało się wczytać konsoli skanera.',
  'topMovers.console.empty': 'Brak zarejestrowanej aktywności. Czekamy na kolejny skan…',
  'topMovers.console.clear': 'Wyczyść konsolę',
  'topMovers.scanNow': 'Skanuj teraz',
  'topMovers.scanRunning': 'Skanowanie…',
  'topMovers.scanError': 'Nie udało się uruchomić ręcznego skanu. Sprawdź konsolę poniżej.',
  'topMovers.engine.active': 'Silnik aktywny',
  'topMovers.engine.modeActive': 'Tryb sentiment_momentum aktywny',
  'topMovers.engine.modeInactive': 'Tryb',
  'topMovers.engine.error': 'Nie udało się wczytać statusu silnika.',
};
